/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespHeroCarouselRequestMoreImages_user$ref = any;
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type PdpRespHeroCarousel_user$ref = any;
export type PdpRespHeroCarousel_user = {
    readonly profile: {
        readonly measurementUnit: MeasurementUnit | null;
    } | null;
    readonly " $fragmentRefs": PdpRespHeroCarouselRequestMoreImages_user$ref;
    readonly " $refType": PdpRespHeroCarousel_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespHeroCarousel_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "measurementUnit",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespHeroCarouselRequestMoreImages_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '647ab6700b00677dc55731d80029f5c2';
export default node;
